import React, { forwardRef, useState } from 'react'
import { MenuItem, Select } from '@mui/material'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'

const SelectPlaceholder = forwardRef((props, ref) => {
  const { value, InputProps, ...other } = props
  const [showPlaceholder, setShowPlaceholder] = useState(!props?.value)
  const NONE = 'none'

  const onFocus = e => {
    setShowPlaceholder(false)
    if (other?.onFocus) other.onFocus(e)
  }

  const onClose = e => {
    setShowPlaceholder(!props?.value)
    if (other?.onClose) other.onClose(e)
  }

  const onChange = e => {
    const { name, value } = e.target
    if (other?.onChange) {
      other.onChange({
        target: { name, value: value === NONE ? '' : value }
      })
    }
  }

  return (
    <Select
      ref={ref}
      value={value || NONE}
      defaultValue={NONE}
      onFocus={onFocus}
      onClose={onClose}
      onChange={onChange}
      IconComponent={ExpandMoreIcon}
      sx={{
        '& .MuiSelect-icon': {
          right: 8,
          position: 'absolute'
        },
        '& .MuiOutlinedInput-input': {
          color: !value && other?.placeholder ? '#b7b9be' : 'inherit',
          padding: '10px 14px',
          fontSize: 14
        }
      }}
      inputProps={{
        ...InputProps
      }}
      {...other}
    >
      {other?.placeholder && (
        <MenuItem sx={{ display: showPlaceholder ? 'block' : 'none' }} key="0" disabled value={NONE}>
          {other?.placeholder}
        </MenuItem>
      )}
      {props.children}
    </Select>
  )
})

export default SelectPlaceholder
